/* @flow */

/**
 * COPIED (with import modifications) FROM EndUserApp src/components/core/resin/components/ResinApplication.js
 */

import { Children, Component } from 'react';
import get from 'lodash/get';
import logger from '../logger';
import resin from '../resin';

const DATA_RESIN_APPLICATION = 'data-resin-application';

type Props = {
  applicationName: string,
  children?: any, // required
  logToConsole?: boolean,
};

class ResinApplication extends Component<Props> {
  componentDidMount() {
    const { applicationName } = this.props;
    const docBody = get(document, 'body');

    resin.start(
      resinData => {
        const { logToConsole = false } = this.props;

        // The free form data object gets flattened before before being sent to Hadoop.
        // This results in new columns being created for every new attribute of the object.
        // Instead we want this object to be stored as a JSON blob...
        if (resinData.data.data) {
          // ... therefore we need to serialize it here as a string, so that it will be used as is.
          resinData.data.data = JSON.stringify(resinData.data.data);
        }

        logger.sendBatchLog('resin', 'web', resinData.data);

        // Distill information into a readable format
        if (logToConsole) {
          resin.logToConsole(resinData.data);
        }
      },
      {
        events: {
          click: 'mouseup',
          keypress: 'keydown',
        },
      },
    );
    const currentApplicationName = docBody.getAttribute(DATA_RESIN_APPLICATION);
    if (applicationName === currentApplicationName) {
      return;
    }
    docBody.setAttribute(DATA_RESIN_APPLICATION, applicationName);
  }

  componentWillUnmount() {
    resin.stop();
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}

export default ResinApplication;
